



import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import MapSidebarOverlay from "./MapSidebarOverlay.vue";
import { FarmMapSummary } from "@/api/farms/types";
import { FarmMapFull } from "@/api/analyses/types";
import { getFarmMapFull } from "@/api/analyses";

 @Component({
   name: 'MapSidebarOverlayController',
   components: {
     MapSidebarOverlay,
   }
 })

export default class MapSidebarOverlayController extends Vue {
  private mapFullInfo: FarmMapFull | null = null; 
  private isLoading: boolean = false;

  @Prop({ type: FarmMapSummary })
  private mapSummaryInfo!: FarmMapSummary;

  @Prop({ type: String })
  private uuid!: string;

  @Prop({ type: Boolean})
  private isMapSideBarVisible!: boolean;

  @Watch('uuid')
  private changeUuid(uuid: string) {
    this.mapFullInfo = null;
    this.getFarmMapFull(uuid);
  }

  private closeSidebar() {
    this.mapFullInfo = null;
    this.$emit("closeMapOverlaySidebar");
  }

   private async getFarmMapFull(uuid: string) {
    this.isLoading = true;
    this.mapFullInfo = null;
    try {
      const response = (await getFarmMapFull(uuid)).data;
      this.mapFullInfo = response;
    } catch {
      this.mapFullInfo = null;
    }
    finally {
    this.isLoading = false;
    }
  }

  private async mounted() {
    await this.getFarmMapFull(this.uuid);
  }

}
